import { propagationAxios } from 'trace-propagation';

import { DetailsApi, SearchSimilarApi, TypeaheadApi, WebSearchApi } from '@videoblocks/search-gateway-client';
import { LoggerFactory } from '@videoblocks/typescript-logger';

import RealClient from './SearchGatewayClient';
import Rules from './rules';
import { searchGatewayConfig } from './searchGatewayConfig';
import { ISearchGatewayClient } from './types';

const logger = LoggerFactory.create('SearchGatewayClient');

function createSearchGatewayClient(): ISearchGatewayClient {
    // Mock client is not supported in production builds to avoid bundling MSW
    // USE_SEARCH_GATEWAY_MOCK should only be used in development/test environments
    if (process.env.USE_SEARCH_GATEWAY_MOCK === 'true') {
        throw new Error(
            'MockSearchGatewayClient cannot be used in production builds. ' +
                'Use USE_SEARCH_GATEWAY_MOCK=true only in development/test environments.',
        );
    }

    // `propagationAxios` forwards incoming propagation headers to search-gateway
    // for Signadot sandbox routing.
    const api = new WebSearchApi(searchGatewayConfig, undefined, propagationAxios);
    const detailsApi = new DetailsApi(searchGatewayConfig, undefined, propagationAxios);
    const typeaheadApi = new TypeaheadApi(searchGatewayConfig, undefined, propagationAxios);
    const searchSimilarApi = new SearchSimilarApi(searchGatewayConfig, undefined, propagationAxios);

    return new RealClient(logger, api, typeaheadApi, searchSimilarApi, detailsApi);
}

const SearchGatewayClient = createSearchGatewayClient();

export * from './SearchUtils';
export * from './types';
export { Rules, SearchGatewayClient };
